export const NODE_LOGO_DATA_ID_CONTRACTS = {
  base: 'node-logo',
  logoContainer: '',
  logo: 'logo-img'
};
